import { createFeatureSelector, createSelector } from "@ngrx/store";
import { PlanMobile } from "..";

export const planMobileStateSelector = createFeatureSelector<PlanMobile>("plan");
export const planMobileSelector = createSelector(planMobileStateSelector, (state) => state?.mobile);
